import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { userService } from '../../services/userService';

export const useUpdateCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: payload =>
      userService.updateCompany(payload).then(response => {
        const { status, data } = response;

        if (status === 200) {
          Notify.success({ text: 'Company updated' });
          queryClient.setQueryData([QUERY_KEYS.user.profile], () => data);
          return data;
        }
        return null;
      }),
  });
};
